import { render, staticRenderFns } from "./stockInTransitTable.vue?vue&type=template&id=6047a13b&scoped=true"
import script from "./stockInTransitTable.vue?vue&type=script&lang=js"
export * from "./stockInTransitTable.vue?vue&type=script&lang=js"
import style0 from "./stockInTransitTable.vue?vue&type=style&index=0&id=6047a13b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6047a13b",
  null
  
)

export default component.exports